import './App.scss';

import { useContext, useRef } from 'react';
import { ThemeContext, ThemeProvider } from './context/ThemeContext';
import { PhotoContainer } from './components/PhotoContainer';
import { FormattedMessage } from 'react-intl';
import { ResumeButton } from './components/ResumeButton';
import { SocialMediaSection } from './components/SocialMediaSection';
import { messages } from './en-NZ';

function App() {
  const sectionsRef = useRef<any>([]);
  const { dark, theme } = useContext(ThemeContext)

  return (
    <ThemeProvider>
      <div id="app" className="app" style={ dark ? theme : {} }>
        <div aria-label="main content" className="main-content">
          <div className="main-content__scrollable" >
            <PhotoContainer />
            <h1 className='main-title'>
              <FormattedMessage id='MAIN_TITLE' />
            </h1>
            <h2 className='subtitle'>
              <FormattedMessage id='SUBTITLE' values={ { br: () => <br /> } } />
            </h2>
            <p className='intro-text'>
              <FormattedMessage id='INTRO_TEXT' values={ {
                br: () => <br />, a: (value) => (
                  <a
                    href={ messages.WEEWATCHER_HOMEPAGE_LINK }
                    target="_blank"
                    rel="noreferrer"
                    referrerPolicy="no-referrer"
                  >
                    { value }
                  </a>
                )
              } } />
            </p>
            <ResumeButton />
            <SocialMediaSection />
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}

export default App;
